import { KK } from '@/define/define'
import { KeyGroup } from '@libs/types/enum'
import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { computed, reactive, watch } from 'vue'
import { DriverService } from './driver'
import { magnetSet } from './magnet_set'
import { KeysGroup, PostMagnetSetKeyDeadZone } from '@libs/types/response'
import { DialogType, enableDialog } from '@/components/cdialog/dialog'
import i18n from '@/languages/i18n'
import { KeyGroupDeadZoneConfig } from '@/define/key_group'
import { DeviceManager } from '../device'
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { getCurrentDeviceAxis } from '@/define/define_switch'
const { t } = i18n.global

class MagnetSetKeyGroup {
  state = reactive({
    keysGroup: new Map<KeyGroup, KK[]>(),
    keysGroupType: KeyGroup.none,
    defaultKeysGroup: null as KeyGroup | null,
    isShowSetKeyGroup: false,
    hoverKeys: [] as KK[],
  })

  hoverKeySet = computed(() => new Set(this.state.hoverKeys))

  // keysGroup = ref<Map<KeyGroup, KK[]>>(new Map()) // 存储所有分组map
  // keysGroupType = ref<KeyGroup>(KeyGroup.none)    // 当前选中的分组的类型
  // defaultKeysGroup: KeyGroup | null = null        // 默认分组（原厂）
  // isShowSetKeyGroup = ref(false)                  // 控制显示设置分组页面
  // hoverKeys = ref<KK[]>([])

  constructor() {
    this.watchKeysGroupType()
  }

  // 需求： 1. 轴体分组, 不同的轴体, 加不同的默认死区.(显示默认死区).加上所有市面上的轴, 并设置默认死区的数值.
  //        2. Royuan的方案的设备,不需要设置死区

  async handleSetKeyGroupDeadZone(kks: KK[], keyGroup: KeyGroup) {
    if (kks.length == 0) {
      return
    }
    if (keyGroup == KeyGroup.none) {
      return
    }
    if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
      return
    }
    if (keyGroup == this.state.defaultKeysGroup) {
      await this.setKeysDeadZone(kks, magnetSet.globalDeadZone.Bottom)
    } else {
      const bottomDeadZone: undefined | number = KeyGroupDeadZoneConfig(keyGroup)?.bottom
      if (bottomDeadZone != undefined) {
        await this.setKeysDeadZone(kks, bottomDeadZone)
      }
    }
    magnetSet.getKeysDeadZone()
  }

  private async setKeysDeadZone(kks: KK[], bottomDeadZone: number) {
    let data = {
      Keys: kks,
      Top: Number(magnetSet.newDeadZone.Top),
      Bottom: bottomDeadZone,
    } as PostMagnetSetKeyDeadZone
    return magnetSet.setKeysDeadZone(data).catch((err) => {
      enableDialog(t('update_dead_zone_error') + err, DialogType.notice, false)
    })
  }

  async setKeysGroupInfo(): Promise<void> {
    let list: KeysGroup[] = []
    this.state.keysGroup.forEach((kks, keyGroup) => {
      if (keyGroup != this.state.defaultKeysGroup) {
        list.push({
          Name: keyGroup,
          Keys: kks,
        } as KeysGroup)
      }
    })
    const data = {
      Type: DriverSocketMsgType.MTSetKeysGroup,
      Data: list,
    } as DriverSocketMsg<any>
    return DriverService.instance.askTypeAndData(data)
  }

  async getKeysGroupInfo() {
    const res = await DriverService.instance.askType<KeysGroup[]>(DriverSocketMsgType.MTGetKeysGroup)
    let groupKKs: KK[] = []
    res.forEach((v, _) => {
      groupKKs = [...groupKKs, ...v.Keys]
      this.state.keysGroup.set(v.Name, v.Keys)
    })
    const default_kks: KK[] = getCurrentDeviceMagnetKKs.value.filter((key) => !groupKKs.includes(key))
    // 获取原厂轴，设置原厂分组
    this.state.defaultKeysGroup = getCurrentDeviceAxis(DeviceManager.instance.state.currentPid)
    this.state.keysGroup.set(this.state.defaultKeysGroup, default_kks)
  }

  watchKeysGroupType() {
    watch(
      () => this.state.keysGroupType,
      (newVal) => {
        if (newVal != KeyGroup.none) {
          let keyData = this.state.keysGroup.get(this.state.keysGroupType)
          if (keyData && keyData.length < getCurrentDeviceMagnetKKs.value.length) {
            magnetSet.magnetData.pressNum = magnetSet.list[keyData[0]].PressNum
            magnetSet.magnetData.quickTriggerPressNum = magnetSet.list[keyData[0]].QuickTriggerPressNum
            magnetSet.magnetData.quickTriggerReleaseNum = magnetSet.list[keyData[0]].QuickTriggerReleaseNum
          }
        }
      },
    )
  }

  clear() {
    this.state.keysGroupType = KeyGroup.none
    this.state.keysGroup.clear()
    this.state.hoverKeys = []
  }
}
let magnetSetKeyGroup = new MagnetSetKeyGroup()
export { magnetSetKeyGroup }
